<template>
    <div class="flex-shrink-0 flex">
        <div class="flex w-32 -ml-px">
            <slot name="price" v-bind="scope">
                <estimates-old-page-cell
                    currency
                    class="text-sm text-right -ml-px -my-px px-2 py-1.5 border border-gray-200"
                    placeholder="Price"
                    :read-only="readOnly"
                    :value="price"
                    @change="updatePrice"
                ></estimates-old-page-cell>
            </slot>
        </div>
        <div class="flex w-32 -ml-px">
            <slot name="coverage" v-bind="scope">
                <estimates-old-page-cell
                    :format="value => `${value} ${uom}`"
                    :decimals="3"
                    class="text-sm text-right -ml-px -my-px px-2 py-1.5 border border-gray-200"
                    placeholder="Coverage"
                    :read-only="readOnly"
                    :value="coverage"
                    @change="updateCoverage"
                ></estimates-old-page-cell>
            </slot>
        </div>
        <div class="flex w-32 -ml-px">
            <slot name="rate" v-bind="scope">
                <estimates-old-page-cell
                    currency
                    class="text-sm text-right -ml-px -my-px px-2 py-1.5 border border-gray-200"
                    placeholder="Rate"
                    :read-only="readOnly"
                    :value="rate"
                    @change="updateRate"
                ></estimates-old-page-cell>
            </slot>
        </div>
    </div>
</template>

<script>
import { asRoundedNumber } from '@utils'

export default {
    props: {
        item: Object,
        uom: String,
        price: Number,
        coverage: Number,
        rate: Number,
        readOnly: Boolean,
    },
    data () {
        return {
            priceFocused: false,
            coverageFocused: false,
            rateFocused: false,
        }
    },
    computed: {
        scope () {
            return {
                price: this.price,
                coverage: asRoundedNumber(this.coverage,3),
                rate: this.rate,
                updatePrice: this.updatePrice,
                updateCoverage: this.updateCoverage,
                updateRate: this.updateRate,
            }
        },
    },
    methods: {
        updatePrice (newPrice) {
            const price = asRoundedNumber(newPrice)
            this.$emit('update:price', price)

            if (! this.coverage) {
                this.$emit('update:coverage', 0.00)
                this.$emit('update:rate', 0.00)
            } else {
                this.$emit('update:rate', asRoundedNumber(parseFloat(price / this.coverage),3))
            }
        },
        updateCoverage (newCoverage) {
            const coverage = asRoundedNumber(newCoverage,3)
            this.$emit('update:coverage', coverage)

            if (! coverage) {
                this.$emit('update:coverage', 0.00)
                this.$emit('update:rate', 0.00)
            } else {
                this.$emit('update:rate', asRoundedNumber(parseFloat(this.price / coverage),3))
            }
        },
        updateRate (newRate) {
            const rate = asRoundedNumber(newRate)
            this.$emit('update:rate', rate)

            if (! this.coverage) {
                this.$emit('update:coverage', 1.00)
            }

            this.$emit('update:price', asRoundedNumber(rate * this.coverage),3)
        },
    },
}
</script>
